import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swiper-previous",
  "use": "icon-swiper-previous-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 13\" id=\"icon-swiper-previous\"><path d=\"M8 11.692V1.308C8 .433 6.955-.02 6.316.578L.778 5.77a1 1 0 0 0 0 1.46l5.538 5.191c.639.6 1.684.146 1.684-.73Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol